import { IEventDetailsExportParams } from "Bands/types";
import { API_ENDPOINTS, API_ERROR_CODES } from "shared/constants";
import { APIService } from "shared/services";
import { IAPIError, IDataKeys, IJSONAPIItem } from "shared/types";

export interface IJSONAPIEventDetailsExport {
  [key: string]: IJSONAPIItem;
}

export interface IJSONAPIEventDetailsExportCollection {
  [IDataKeys.eventDetailsExport]: IJSONAPIEventDetailsExport;
  meta: {
    [key: string]: IJSONAPIItem;
  };
  pagination: any;
}

export interface IJSONAPILastGuestlistSentCollection {
  [IDataKeys.lastGuestlistSent]: IJSONAPIEventDetailsExport;
  meta: {
    [key: string]: IJSONAPIItem;
  };
  pagination: any;
}

export class EventDetailsExportService {
  static createEventDetailsExport = (
    data: IEventDetailsExportParams
  ): Promise<IJSONAPIEventDetailsExportCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const response = await APIService.post({
          path: API_ENDPOINTS.EVENT_DETAILS_EXPORT,
          data,
        });

        resolve(response);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.CREATE_EVENT_DETAILS_EXPORT);
        return reject(error);
      }
    });

  static getEventDetailsExport = (id: string): Promise<IJSONAPIEventDetailsExportCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const response = await APIService.get({
          path: API_ENDPOINTS.EVENT_DETAILS_EXPORT_CONFIG(id),
        });

        resolve(response);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.GET_EVENT_DETAILS_EXPORT);
        return reject(error);
      }
    });

  static getLastEventDetailsExportSent = (
    id: string
  ): Promise<IJSONAPIEventDetailsExportCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const response = await APIService.get({
          path: API_ENDPOINTS.EVENT_DETAILS_EXPORT_CONFIG(id),
        });

        response[IDataKeys.lastEventDetailsExportSent] = response[IDataKeys.eventDetailsExport];

        delete response[IDataKeys.eventDetailsExport];

        resolve(response);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.GET_EVENT_DETAILS_EXPORT);
        return reject(error);
      }
    });

  static getLastGuestlistSent = (id: string): Promise<IJSONAPILastGuestlistSentCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const response = await APIService.get({
          path: API_ENDPOINTS.EVENT_DETAILS_EXPORT_CONFIG(id),
        });

        response[IDataKeys.lastGuestlistSent] = response[IDataKeys.eventDetailsExport];

        delete response[IDataKeys.eventDetailsExport];

        resolve(response);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.GET_EVENT_DETAILS_EXPORT);
        return reject(error);
      }
    });
}
